import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./admin_page.css";
const config = require('../config');
const host = config.host;
const port = config.port;

export const AdminPage = () => {
    const [searchTerm, setSearchTerm] = useState('');
    // const [imageURL, setImageURL] = useState('');
    // const [latest_keyword, setLatestKeyword] = useState("");
    // const [previous_keywords, setPreviousKeywords] = useState("");
    const [imagesAndKeywords, setImagesAndKeywords] = useState([]);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const navigate = useNavigate();

    // Fetch all users on component mount
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const token = sessionStorage.getItem("token");
                const response = await fetch(`/users/all_users`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                });
                
                if (!response.ok) throw new Error('Failed to fetch users');
                
                const data = await response.json();
                console.log(data.users)
                setUsers(data.users);
                setLoading(false);
            } catch (err) {
                console.error('Error fetching users:', err);
                setError('Failed to load users');
                setLoading(false);
            }
        };

        fetchUsers();
    }, []);

    const handleSearch = (event) => {
        event.preventDefault();
        if (!searchTerm) return;

        const token = sessionStorage.getItem("token");
        fetch(`/users/image_and_keywords?phone_no=${searchTerm}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })
        .then(response => {
            if (!response.ok) throw new Error('User not found');
            return response.json();
        })
        .then(data => {
            // Expecting data.images_and_keywords to be an array of { image, keyword }
            
            setImagesAndKeywords(data.images_and_keywords.map(item => ({
                image: `data:image/jpeg;base64, ${item.image}`,
                keyword: item.keyword
            })));
            
            setError('');
        })
        .catch(error => {
            console.error('Search error:', error);
            setError('User not found');
            setImagesAndKeywords([]);
        });
    };

    return (
        <div className="admin-container">
            <h1>Admin Dashboard</h1>
            
            {/* Search Section */}
            <div className="search-section">
                <div className="search-box">
                    <input
                        type="text"
                        placeholder="Search by phone number"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button onClick={handleSearch}>Search</button>
                </div>
                
                {error && <p className="error-message">{error}</p>}
                
                {imagesAndKeywords.length > 0 && (
                    <div className="user-info">
                        {imagesAndKeywords.map((item, index) => (
                            <div key={index} className="image-keyword-pair">
                                <img src={item.image} alt={`user-${index}`} className="user-image" />
                                <p className="keyword-info"><strong>Keyword:</strong> {item.keyword}</p>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Users Table */}
            <div className="users-table">
                <h2>All Users</h2>
                {loading ? (
                    <div className="loading">Loading users...</div>
                ) : error ? (
                    <div className="error-message">{error}</div>
                ) : (
                    <table>
                        <thead>
                            <tr>
                                <th>Phone Number</th>
                                {/* <th>Image</th> */}
                                <th>Role</th>
                                <th>Quota</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map(user => (
                                <tr key={user.phone_number}>
                                    <td>{user.phone_number}</td> {/* phone number is ID */}
                                    <td>{user.role}</td>
                                    <td>{user.quota}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};
